/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),

    // Equal height elements
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),

    // Product page
    $productImage: $('#ProductPhotoImg'),
    $productImageGallery: $('.gallery__item'),

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',

    // Add to cart - Ajax
    $cartCount: $('.cart-count'),
    $addToCartBtn: $('form[action^="/cart/add"] :submit')
  }
};

theme.init = function () {
  theme.cacheSelectors();
  theme.mobileNav();
  theme.equalHeights();
  theme.cartPage();

  

  
    theme.enableAjax();
  
};

theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(220);
  });

  theme.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};

theme.equalHeights = function () {
  theme.cache.$w.on('load', resizeElements());

  theme.cache.$w.on('resize',
    afterResize(function() {
      resizeElements();
    }, 250, 'equal-heights')
  );

  function resizeElements() {
    theme.cache.$productGridImages.css('height', 'auto').equalHeights();
    theme.cache.$featuredGridImages.css('height', 'auto').equalHeights();
  }
};

theme.productImageGallery = function() {

  if (!theme.cache.$productImageGallery.length) {
    return;
  };

  theme.cache.$productImageGallery.magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: true,
    tClose: 'Close (Esc)',
    removalDelay: 500,
    callbacks: {
      open: function(){
        $('html').css('overflow-y','hidden');
      },
      close: function(){
        $('html').css('overflow-y','');
      }
    },
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)'
    }
  });

  theme.cache.$productImage.bind('click', function() {
    var imageId = $(this).attr('data-image-id');
    theme.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });
};

theme.cartPage = function () {
  
    return;
  

  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });
};

theme.backButton = function () {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  }
};

theme.addToCartflip = function ($addToCartBtn) {

  // Get label of add to cart button
  var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to Cart";
  // Make a copy of the add to cart button should we flip it
  // $addToCartBtn
  //   .clone(true)
  //   .prop('disabled', false)
  //   .removeClass('disabled')
  //   .addClass('btn--unflipped')
  //   .find('span')
  //   .text(addToCartText)
  //   .end()
  //   .hide()
  //   .insertAfter($addToCartBtn);

  // $addToCartBtn
  //   .unbind('click')
  //   .removeClass('disabled')
  //   .find('span')
  //   .text("View cart")
  //   .end()
  //   .bind('click', function(e) {
  //     e.preventDefault();
  //     window.location.href = '/cart';
  //   })
  //   .prop('disabled', false)
  //   .addClass('btn--flipped')
  //   .after('<span class="continue-shopping 1"> <a class="btn--secondary" href="/collections/all">Continue shopping</a></span>');

  $('.continue-shopping a').bind('click', theme.backButton);

  // Unflip button if another variant is selected
  $('.single-option-selector, [name="quantity"]').bind('click', function() {
    $(this).closest('form').find('.btn--flipped, .continue-shopping, .note').remove();
    $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};
var interval;
theme.enableAjax = function () {
  $('body').on('click', 'form[action^="/cart/add"] :submit', function(e) {
    e.preventDefault();
    $('.note.errors').remove();
    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
        $addToCartBtnText = $(this).find('span');
    if ($addToCartForm.length) {
      $addToCartBtn
        .attr('data-add-to-cart', $addToCartBtnText.text())
        //.prop('disabled', true)
        //.addClass('disabled')
        .addClass('btn--loading');
      
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(lineItem) {
          $.getJSON('/cart.js', function(cart) {
            theme.cache.$cartCount.text(cart.item_count);
            $('.hidden-count').removeClass('hidden-count');
          });
          $addToCartBtn.removeClass('btn--loading');
          theme.addToCartflip($addToCartBtn);
          // Remove Cart after 2h
            // Set time cookie
              var date = new Date();
              var minutes = 2; // Number hour
              date.setTime(date.getTime() + (minutes * 60 * 60 * 1000));
          		//date.setTime(date.getTime() + (minutes * 60 * 1000));
            // #Set time cookie
          	if($.cookie("cart_empty") != 'undefined'){
          		$.cookie("cart_empty", "1", { expires: date, path: '/'}); 
            }
          // Show Popup Added
            var name_ = $(this).closest('.item_pro').find('.name_ a').text();
            $('.popup_cart_ .name_p').text(name_);

//           countdowntime
          var timer2 = "180:00";
          const currentDate = new Date();
		const timestamp = currentDate.getTime();
          $('.countdown').html(timer2);
         localStorage.setItem("countdown",timestamp);
          clearInterval(interval);
          interval = setInterval(function() {


            var timer = timer2.split(':');
            //console.log(timer);
            //by parsing integer, I avoid all extra string processing
            var minutes = parseInt(timer[0], 10);
            var seconds = parseInt(timer[1], 10);
            --seconds;
            minutes = (seconds < 0) ? --minutes : minutes;
            if (minutes < 0) clearInterval(interval);
            seconds = (seconds < 0) ? 59 : seconds;
            seconds = (seconds < 10) ? '0' + seconds : seconds;
            //minutes = (minutes < 10) ?  minutes : minutes;
            $('.countdown').html(minutes + ':' + seconds);
            timer2 = minutes + ':' + seconds;

          }, 1000);
          
            setTimeout(function(){ $('#myModal').modal();$('#wishlist-temp').css('display','block'); }, 1000);
        },
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text("Sold Out");
          }
          else {
              //$('.addcart_ #AddToCart').click(function(){
                //var name_ = $(this).closest('.item_pro').find('.name_ a').text();
                $('.popup_cart_ .name_p').html('<p class="note errors">' + response + '</p>');
                setTimeout(function(){ $('#myModal').modal(); }, 2000);
              //});                                    
                       
            //$addToCartBtn.prop('disabled', false).removeClass('disabled');
            //$addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }
         // $addToCartBtn.after('<p class="note errors">' + response + '</p>');
        }
      });
    }
  });
};

 
const currentDate = new Date();
const timestamp = currentDate.getTime();
var timer2 = "180:00";
// Store
var timestamp2 = Number(localStorage.getItem("countdown"));
timestamp2 = timestamp2 + 10800000
var minute = timestamp2 - timestamp;
// if(minute <= 0){
//   timer2 = '00:00';
//   $('.time-cart').remove();
//   $.ajax({
//     type: "POST",
//     url: '/cart/clear.js',
//     success: function(){
//     },
//     dataType: 'json'
//   });
// }else{
//   timer2 = convertMiute(minute);
//   $('.timedown').html(timer2);
//   $('.time-cart').show();
//   var interval2 = setInterval(function() {
//     var timer = timer2.split(':');
//     //by parsing integer, I avoid all extra string processing
//     var minutes = parseInt(timer[0], 10);
//     var seconds = parseInt(timer[1], 10);
//     --seconds;
//     minutes = (seconds < 0) ? --minutes : minutes;
//     //console.log(minutes,'minutes');
//     if (minutes < 0){
//       clearInterval(interval2);
//       $('.time-cart').remove();
//       //console.log(minutes,'minutes2');
//       $.ajax({
//         type: "POST",
//         url: '/cart/clear.js',
//         success: function(){
//           	window.location.reload();
//         },
//         dataType: 'json'
//       });

//     } 
//     seconds = (seconds < 0) ? 59 : seconds;
//     seconds = (seconds < 10) ? '0' + seconds : seconds;
//     //minutes = (minutes < 10) ?  minutes : minutes;
//     $('.timedown').html(minutes + ':' + seconds);
//     timer2 = minutes + ':' + seconds;
//   }, 1000);
// }
  
  
  $(document).on('click','.renew-timer', function(){
  	timer2 = "10:00";
    const currentDate = new Date();
    const timestamp = currentDate.getTime();
    $('.timedown').html(timer2);
    localStorage.setItem("countdown",timestamp);
  });
  function convertMiute(minute){
  	var m = Math.floor(minute/60000);
    var t = minute - m * 60000;
    var s = Math.floor(t/1000);
    return m + ':' + s;
  }

$(window).on('load', function(){
  //console.log(123);
  if($('#order-summary').length){
    if(timer2 != '00:00'){
    	var html =`<div class="time-group time-cart" style="display:none;">
      	<img src="https://cdn.shopify.com/s/files/1/1267/4059/files/image_2021_06_25T03_00_26_387Z.png?v=1624590054" alt="hot">
        <span class="content-time">Due to popular demand, your items are reserved in your cart for <span class="timedown">`+timer2+`</span> minutes. Your timer will renew everytime you add another item into your cart.</span>
        <button href="javascript:void(0);" type="button" class="renew-timer">Renew timer</button>
      </div>`;
      $('.section__header').append(html);
    }
    
  }
});

// Initialize theme's JS on docready
$(theme.init)
